module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"reminders-frequency":"Reminders frequency"},"fr":{"reminders-frequency":"Fréquence des rappels"}}')
  delete Component.options._Ctor
}
